import Cookies from 'js-cookie'

const TokenKey = 'Admin-CoCo-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getItem(lName) {
  if (lName === 'userInfo') {
    return JSON.parse(localStorage.getItem(lName));
  } else {
    return localStorage.getItem(lName);
  }
}

export function setItem(lName, vo) {
  if (typeof vo === 'string') {
    return localStorage.setItem(lName, vo);
  } else {
    return localStorage.setItem(lName, JSON.stringify(vo));
  }
}

export function removeItem(lName) {
  return localStorage.removeItem(lName);
}

const AuthTraceKey = 'authTrace'

function padTime(n) {
  return n < 10 ? '0' + n : '' + n
}

// 登录态相关事件留痕（自动登出 + 信令异常等关联事件）。
// 现场排查"没人操作却掉回登录页"时执行：
// console.table(JSON.parse(localStorage.getItem('authTrace') || '[]'))
export function traceAuth(reason) {
  const now = new Date()
  const at = now.getFullYear() + '-' + padTime(now.getMonth() + 1) + '-' + padTime(now.getDate()) +
    ' ' + padTime(now.getHours()) + ':' + padTime(now.getMinutes()) + ':' + padTime(now.getSeconds())
  let list = []
  try {
    const saved = JSON.parse(localStorage.getItem(AuthTraceKey) || '[]')
    // 留痕一旦损坏就重置，否则后续事件再也记不上
    if (Array.isArray(saved)) list = saved
  } catch (e) {
    list = []
  }
  list.push({ at: at, page: window.location.hash, reason: reason })
  try {
    localStorage.setItem(AuthTraceKey, JSON.stringify(list.slice(-50)))
  } catch (e) {
    // 留痕只用于诊断，存储不可用时不能影响登出流程
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js